import React from 'react'
import { Grid } from '@mui/material'
import EngagementAppLogo from '../../../../../../assets/images/EngagementAppLogo.png'
import QRCode from '../../../../../Common/QRCode'
import CopyInputField from '../../../../../Common/CopyInputField'
import { EventDetails } from '../../../../../../redux/event/teamMemberEvents/types'

interface EventShareTabProps {
  eventDetail: EventDetails
}

const EventShareTab: React.FC<EventShareTabProps> = ({ eventDetail }) => {
  return (
    <Grid container spacing={2} direction='column'>
      <Grid>
        <QRCode
          value={`${window.location.origin}/events/${eventDetail.registrationCode}`}
          logoImage={EngagementAppLogo}
          size={200}
          logoSize={40}
          filename={`Event_Registration_${eventDetail.registrationCode}`}
        />
      </Grid>
      <Grid>
        <CopyInputField
          value={`${window.location.origin}/events/${eventDetail.registrationCode}`}
          label='REGISTRATION LINK'
        />
      </Grid>
    </Grid>
  )
}

export default EventShareTab
